import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The npm command line interface (CLI) is released on a regular cadence. We recommend installing the release that supports your workflow:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#the-latest-release-of-npm"
        }}>{`latest release`}</a>{`: the most recent stable version.`}</li>
    </ul>
    <h2>{`The `}<inlineCode parentName="h2">{`latest`}</inlineCode>{` release of npm`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`latest`}</inlineCode>{` release of npm is the most recent stable version. When you install Node.js, npm is automatically installed. However, npm is released more frequently than Node.js, so to install the latest stable version of npm, on the command line, run:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install npm@latest -g
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      